<template>
  <!-- MODAL RESULT -->
  <b-modal ref="result" title="Update Result" centered cancel-variant="outline-secondary" size="md" hide-footer
    @hide="hideModal" @shown="fetchEventDetail">

    <div v-if="eventItem && eventItem.source !== 'sporting'">

      <div style="color: black" v-if="eventItem">
        <!-- MARKET HANDICAP OR PRIMARY MARKET -->
        <div v-if="
          selectedMarket &&
          eventItem &&
          (checkShowHandicapResult() ||
            selectedMarket.name === eventItem.primaryMarketName)
        ">
          <div v-for="item in selectedMarket.selections" :key="item.marketSelectionId" style="
            padding-bottom: 10px;
            border-bottom: 1px solid black;
            margin-bottom: 10px;
          ">
            <p>
              <span style="font-weight: bold">Selection Name: </span>
              {{ item.selectionName }}
            </p>
            <p><span style="font-weight: bold"> Role:</span> {{ item.role }}</p>

            <!-- RESULT -->
            <b-row class="mt-2">
              <b-col cols="12" sm="3" class="d-flex align-items-center">
                <div class="font-weight-bold">Result</div>
              </b-col>
              <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column">
                <p v-if="checkShowHandicapResult()" style="margin: 0">Handicap</p>
                <b-form-radio-group v-else :id="`radio-inline-${item.marketSelectionId}`" v-model="item.result"
                  :options="item.marketType === 'Line' || item.marketType === 'FlatLine'
                    ? optionsResult
                    : optionsResult.filter((i) => i.value !== 'Draw')
                    " :name="`radio-inline-${item.marketSelectionId}`" />
              </b-col>
            </b-row>

            <!-- winPriceResult -->
            <b-row class="mt-2">
              <b-col cols="3">
                <div class="font-weight-bold">winPriceResult</div>
                <small>(Optional)</small>
              </b-col>
              <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
                <b-form-input v-model="item.winPriceResult" />
              </b-col>
            </b-row>

            <!-- handicap -->
            <b-row v-if="checkShowHandicapResult()" class="mt-2">
              <b-col cols="12" sm="3" class="d-flex align-items-center">
                <div class="font-weight-bold">handicap</div>
              </b-col>
              <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
                <b-form-input v-model="item.handicap" />
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- MARKET NO HANDICAP -->
        <div v-else-if="selectedSelection">
          <div style="
            padding-bottom: 10px;
            border-bottom: 1px solid black;
            margin-bottom: 10px;
          ">
            <p>
              <span style="font-weight: bold">Selection Name: </span>
              {{ selectedSelection.selectionName }}
            </p>
            <p>
              <span style="font-weight: bold"> Role:</span>
              {{ selectedSelection.role }}
            </p>

            <!-- RESULT -->
            <b-row class="mt-2">
              <b-col cols="12" sm="4" class="d-flex align-items-center">
                <div class="font-weight-bold">Result</div>
              </b-col>
              <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column">
                <p v-if="checkShowHandicapResult()" style="margin: 0">Handicap</p>
                <b-form-radio-group v-else :id="`radio-inline-${selectedSelection.marketSelectionId}`"
                  v-model="selectedSelection.result" :options="optionsResult"
                  :name="`radio-inline-${selectedSelection.marketSelectionId}`" />
              </b-col>
            </b-row>

            <!-- winPriceResult -->
            <b-row class="mt-2">
              <b-col>
                <div class="font-weight-bold">winPriceResult</div>
                <small>(Optional)</small>
              </b-col>
              <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
                <b-form-input v-model="selectedSelection.winPriceResult" />
              </b-col>
            </b-row>

            <!-- RESULT -->
            <b-row v-if="!checkShowHandicapResult() && !eventItem.primaryMarketName" class="mt-2">
              <b-col cols="12" sm="4" class="d-flex align-items-center">
                <div class="font-weight-bold">Is Primary Market</div>
              </b-col>
              <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column">
                <b-form-radio-group :id="`radio-primary-market-${selectedSelection.marketSelectionId}`"
                  v-model="checkIsPrimaryMarket" :options="optionsIsPrimaryMarket"
                  :name="`radio-primary-market-${selectedSelection.marketSelectionId}`" />
              </b-col>
            </b-row>

            <!-- handicap -->
            <b-row v-if="checkShowHandicapResult()" class="mt-2">
              <b-col cols="12" sm="4" class="d-flex align-items-center">
                <div class="font-weight-bold">handicap</div>
              </b-col>
              <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
                <b-form-input v-model="selectedSelection.handicap" />
              </b-col>
            </b-row>
          </div>
          <small v-if="errorResult" class="text-danger">{{ errorResult }}</small>
        </div>
      </div>

      <!-- handicap result -->
      <b-row v-if="checkShowHandicapResult()" class="mt-2" style="color: black !important">
        <b-col cols="12" sm="3" class="d-flex align-items-center">
          <div class="font-weight-bold">handicapResult</div>
        </b-col>
        <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column; gap: 12px">
          <b-form-input v-model="handicapResult" />
        </b-col>
      </b-row>
      <!-- handicap market -->
      <b-row v-if="checkShowHandicapResult()" class="mt-2" style="color: black !important">
        <b-col cols="12" sm="3" class="d-flex flex-column">
          <div class="font-weight-bold">Handicap Market</div>
          <small>(Optional)</small>
        </b-col>
        <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column; gap: 12px">
          <b-form-input v-model="handicapMarket" :formatter="formatNumber" />
        </b-col>
      </b-row>
      <small v-if="checkShowHandicapResult() && errorHandicap" class="text-danger d-block mt-1">
        {{ errorHandicap }}
      </small>
    </div>


    <div style="color: black" v-if="eventItem && eventItem.source === 'sporting'">
      <!-- MARKET HANDICAP OR PRIMARY MARKET -->
      <div v-if="selectedSelection && eventItem">
        <!-- handicap -->
        <p>Market Name: {{ selectedMarket && selectedMarket.name ? selectedMarket.name : '' }}</p>
        <!-- Scores -->
        <p>Scores {{ getTypeToCalculateResult(selectedMarket) != null ? '(Required)' : '(Optional)' }}:</p>
        <b-row v-if="getTypeToCalculateResult(selectedMarket) != null" class="mt-2" style="row-gap: 8px">
          <b-col cols="12" sm="4">
            <div class="font-weight-bold">Score Home</div>
            <b-form-input v-model="scoreHome" :formatter="formatNumber" />
          </b-col>
          <b-col cols="12" sm="4">
            <div class="font-weight-bold">Score Away</div>
            <b-form-input v-model="scoreAway" :formatter="formatNumber" />
          </b-col>
          <b-col cols="12" sm="4">
            <div class="font-weight-bold">Score Total</div>
            <b-form-input v-model="scoreTotal" :formatter="formatNumber" />
          </b-col>
        </b-row>
        <b-row class="mt-1 mb-1">
          <b-col cols="12" sm="3" class="d-flex flex-column">
            <div class="font-weight-bold">Handicap Market</div>
            <small>(Optional)</small>
          </b-col>
          <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
            <b-form-input v-model="selectedMarket.handicap" :formatter="formatNumber" />
          </b-col>
        </b-row>
        <p>
          <span style="font-weight: bold">Selection Name: </span>
          {{ selectedSelection.selectionName }}
        </p>
        <p><span style="font-weight: bold"> Role:</span> {{ selectedSelection.role }}</p>

        <!-- RESULT -->
        <b-row v-if="!getTypeToCalculateResult(selectedMarket)" class="mt-2">
          <b-col cols="12" sm="3" class="d-flex align-items-center">
            <div class="font-weight-bold">Result</div>
          </b-col>
          <b-col cols="12" sm="8" class="d-flex" style="flex-direction: column">
            <b-form-radio-group :id="`radio-inline-${selectedSelection.marketSelectionId}`"
              v-model="selectedSelection.result" :options="optionsResult"
              :name="`radio-inline-${selectedSelection.marketSelectionId}`" />
          </b-col>
        </b-row>

        <!-- winPrice -->
        <b-row class="mt-2">
          <b-col cols="3">
            <div class="font-weight-bold">winPrice</div>
            <small>(Optional)</small>
          </b-col>
          <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
            <b-form-input v-model="selectedSelection.winPrice" :formatter="formatNumber" />
          </b-col>
        </b-row>

        <!-- handicap -->
        <b-row class="mt-2">
          <b-col cols="12" sm="3" class="d-flex flex-column">
            <div class="font-weight-bold">Handicap Selection</div>
            <small>(Optional)</small>
          </b-col>
          <b-col cols="8" class="d-flex" style="flex-direction: column; gap: 12px">
            <b-form-input v-model="selectedSelection.handicap" :formatter="formatNumber" />
            <b-form-checkbox v-model="isDraw" class="mt-2">
              Draw
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

    </div>

    <b-row>
      <b-col class="d-flex justify-content-end mt-2">
        <b-button variant="primary" class="mb-1 mb-sm-0" :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="handleUpdateResultSelection">
          <Spinner v-if="loadingUpdateResultSelection" />
          <span v-else>Save</span>
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCard,
  BCol,
  BMedia,
  BRow,
  BTable,
  VBModal,
  BDropdown,
  BDropdownItem,
  BCardText,
  BButton,
  BListGroupItem,
  BFormInput,
  BBadge,
  BFormRadioGroup,
  BFormCheckbox,
  BPagination,
} from "bootstrap-vue";

import { mapActions, mapState } from "vuex";
import { computed, ref, watch } from "@vue/composition-api";
import Spinner from "@core/components/Spinner";
import { objectProp } from "@/helpers/props";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BDropdown,
    BDropdownItem,
    BCardText,
    BButton,
    Spinner,
    BListGroupItem,
    BFormInput,
    BBadge,
    BFormRadioGroup,
    BFormCheckbox,
    BPagination,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    activeSelection: objectProp(),
  },
  data() {
    return {
      type: "",
      modal: {
        title: "",
        content: "",
      },
      listMarkets: [],
      logo: "",
      isEdit: false,

      handicap: null,
      handicapMarket: null,
      handicapResult: null,
      selectedMarket: null,
      optionsResult: [
        { text: "Win", value: "Win" },
        { text: "Lose", value: "Lose" },
        // { text: "Draw", value: "Draw" },
      ],

      optionsIsPrimaryMarket: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],

      checkIsPrimaryMarket: false,
      errorResult: "",
      errorHandicap: "",
      eventItem: null,
      selectedSelection: null,
      isDraw: false,
      scoreHome: null,
      scoreAway: null,
      scoreTotal: null,
    };
  },
  computed: {
    ...mapState("sport/create", ["loadingUpdateResultSelection"]),
  },

  methods: {
    ...mapActions({
      getListEventOfLeague: "trading/sport/getNextToGoSport",
      getListMarketOfEvent: "sport/list/getListMarketOfEventEncode",
      updateResultSelection: "sport/create/addResultManual",
      addResultSportingManual: "sport/create/addResultSportingManual",
      recalculateResult: "sport/create/recalculateResult",
    }),
    openModal() {
      this.$refs.result.show();
    },
    async fetchEventDetail() {
      const res = await this.getListEventOfLeague({
        limit: 1,
        eventId: this.activeSelection.eventId,
      });
      console.log('res', res);
      if (Array.isArray(res)) {
        this.eventItem = res[0];
      }
      if (this.eventItem) {
        const dataMarket = await this.getListMarketOfEvent({
          limit: 1,
          eventId: this.activeSelection.eventId,
          "names[0]": this.activeSelection.marketName,
        });
        if (Array.isArray(dataMarket.data)) {
          this.selectedMarket = dataMarket.data[0];
          const selection = dataMarket.data[0].selections.find(
            (i) => i.marketSelectionId === this.activeSelection.selectionId
          );
          this.selectedSelection = selection ? selection : {
            marketSelectionId: this.activeSelection.selectionId,
            selectionName: this.activeSelection.name ? this.activeSelection.name : '',
            role: this.activeSelection.role,
            result: null,
            winPriceResult: null,
            handicap: null,
          }
        }
      }
    },
    async handleUpdateResultSelection() {
      if (this.eventItem.source === 'sporting') {
        return this.handleUpdateResultSporting();
      }
      // Totals markets have no Win/Lose result: each selection needs a handicap plus the market handicapResult
      if (this.checkShowHandicapResult()) {
        const isEmpty = (v) => v === null || v === undefined || v === "";
        if (this.selectedMarket.selections.some((i) => isEmpty(i.handicap))) {
          this.errorHandicap = "Handicap is required for every selection!";
          return;
        }
        if (isEmpty(this.handicapResult)) {
          this.errorHandicap = "handicapResult is required!";
          return;
        }
        this.errorHandicap = "";
        return this.saveResultHandicap();
      }
      if (this.selectedMarket.name === this.eventItem.primaryMarketName) {
        if (
          this.selectedMarket.selections.some(
            (i) => !i.result
          )
        ) {
          return (this.errorResult =
            "The field result and winPrice are required!");
        }
        this.errorResult = "";
        const data = {
          EventID: this.eventItem.eventId,
          Markets: [
            {
              ExternalID: this.selectedMarket.marketId,
              MarketType: this.selectedMarket.marketType,
              isPrimaryMarket:
                this.selectedMarket.name === this.eventItem.primaryMarketName ||
                this.checkIsPrimaryMarket,
              ...(this.checkShowHandicapResult() && {
                HandicapResult: Number(this.handicapResult),
              }),
              Selections: this.selectedMarket.selections.map((i) => ({
                ExternalID: i.marketSelectionId,
                Role: i.role,
                WinPrice: Number(i.winPriceResult),
                Result: this.checkShowHandicapResult() ? "Handicap" : i.result,
                ...(this.checkShowHandicapResult() && {
                  Handicap: Number(i.handicap),
                }),
              })),
            },
          ],
          isFinished:
            this.selectedMarket.name === this.eventItem.primaryMarketName ||
            this.checkIsPrimaryMarket,
        };
        const res = await this.updateResultSelection(data);
        if (res) {
          await this.recalculateResult(this.eventItem.eventId);
          this.showToastSuccess(
            "Success",
            "Update data selection successfully!"
          );
          this.$refs.result.hide();
          this.hideModal();
        }
        return;
      }
      if (this.errorResult || this.errorWinPrice) return;
      const data = {
        EventID: this.eventItem.eventId,
        Markets: [
          {
            ExternalID: this.selectedMarket.marketId,
            MarketType: this.selectedMarket.marketType,
            isPrimaryMarket:
              this.selectedMarket.name === this.eventItem.primaryMarketName ||
              this.checkIsPrimaryMarket,
            ...(this.checkShowHandicapResult() && {
              HandicapResult: Number(this.handicapResult),
            }),

            Selections: [
              {
                ExternalID: this.selectedSelection.marketSelectionId,
                Role: this.selectedSelection.role,
                WinPrice: Number(this.selectedSelection.winPriceResult),
                Result: this.checkShowHandicapResult()
                  ? "Handicap"
                  : this.selectedSelection.result,
                ...(this.checkShowHandicapResult() && {
                  Handicap: Number(this.selectedSelection.handicap),
                }),
              },
            ],
          },
        ],
        isFinished:
          this.selectedMarket.name === this.eventItem.primaryMarketName ||
          this.checkIsPrimaryMarket,
      };
      const res = await this.updateResultSelection(data);
      if (res) {
        await this.recalculateResult(this.eventItem.eventId);
        this.showToastSuccess("Success", "Update data selection successfully!");
        this.$refs.result.hide();
        this.hideModal();
      }
    },
    async saveResultHandicap() {
      const data = {
        EventID: this.activeSelection.eventId,
        Markets: [
          {
            ExternalID: this.selectedMarket.marketId,
            MarketType: this.selectedMarket.marketType,
            isPrimaryMarket:
              this.selectedMarket.name === this.eventItem.primaryMarketName,
            ...(this.checkShowHandicapResult() && {
              HandicapResult: Number(this.handicapResult),
            }),
            ...(this.handicapMarket !== null &&
              this.handicapMarket !== "" && {
                Handicap: Number(this.handicapMarket),
              }),

            Selections: this.selectedMarket.selections.map((i) => ({
              ExternalID: i.marketSelectionId,
              Role: i.role,
              WinPrice: Number(i.winPriceResult),
              Result: "Handicap",
              Handicap: Number(i.handicap),
            })),
          },
        ],
        isFinished:
          this.selectedMarket.name === this.eventItem.primaryMarketName,
      };
      const res = await this.updateResultSelection(data);
      if (res) {
        await this.recalculateResult(this.eventItem.eventId);
        this.showToastSuccess("Success", "Update data selection successfully!");
        this.$refs.result.hide();
        this.hideModal();
      }
    },
    async handleUpdateResultSporting() {
      const requireScores = this.getTypeToCalculateResult(this.selectedMarket) != null;
      const isEmpty = (v) => v === null || v === undefined || v === '';
      if (
        requireScores &&
        (isEmpty(this.scoreHome) || isEmpty(this.scoreAway) || isEmpty(this.scoreTotal))
      ) {
        this.showToastError(
          'Error',
          'Score Home, Score Away and Score Total are required!'
        );
        return;
      }
      const res = await this.addResultSportingManual({
        EventID: this.eventItem.eventId,
        isFinished: false,

        Markets: [
          {
            ExternalID: this.selectedMarket.marketId,
            MarketType: this.selectedMarket.marketType,
            ...(!!this.selectedMarket.handicap && {
              Handicap: this.selectedMarket.handicap,
            }),
            Selections: [
              {
                ExternalID: this.selectedSelection.marketSelectionId,
                Role: this.selectedSelection.role,
                WinPrice: Number(this.selectedSelection.winPrice),
                ...(!this.getTypeToCalculateResult(this.selectedMarket) && { Result: this.selectedSelection.result }),
                ...(!!this.selectedSelection.handicap && {
                  Handicap: this.selectedSelection.handicap,
                }),
                ...(this.isDraw && {
                  type: "draw",
                }),
              },
            ],
            ...(!!this.scoreHome && !!this.scoreAway && !!this.scoreTotal && {
              Scores: {
                scoreHome: Number(this.scoreHome),
                scoreAway: Number(this.scoreAway),
                scoreTotal: Number(this.scoreTotal),
              },
            }),
          },
        ],
      });
      if (res) {
        await this.recalculateResult(this.eventItem.eventId);
        this.showToastSuccess("Success", "Update data selection successfully!");
        this.$refs.result.hide();
        this.hideModal();
      }
    },
    getTypeToCalculateResult(market) {
      const type = (market?.marketType ?? '').toLowerCase()
      if (!type.includes('rolling')) return undefined
      if (type.includes('match_winner') && type.includes('double')) return undefined
      if (type.includes('handicap') || type.includes('spread')) return 'line'
      if (type.includes('total') || type.includes('over/under') || type.includes('over_under')) return 'total'
      return undefined
    },
    checkShowHandicapResult() {
      return (
        this.selectedMarket &&
        (this.selectedMarket.marketType === "FlatTotal" ||
          this.selectedMarket.marketType === "Totals")
      );
    },
    async handleRecalculateResultEvent() {
      const result = await this.recalculateBettingResult(
        this.eventItem.eventId
      );
      if (!result) return;
      this.showToastSuccess(
        "Success",
        "Recalculate event result successfully!"
      );
    },
    hideModal() {
      this.$emit("hideResult");
      this.eventItem = null;
      this.selectedMarket = null;
      this.handicap = null;
      this.handicapMarket = null;
      this.handicapResult = null;
      this.errorHandicap = "";
      this.checkIsPrimaryMarket = false;
      this.isDraw = false;
      this.scoreHome = null;
      this.scoreAway = null;
      this.scoreTotal = null;
    },
    formatNumber(value) {
      const regexNumber = /^[0-9.]+$/;

      if (regexNumber.test(value)) {
        if (value.split("").filter((s) => s === ".").length > 1) return;
        return value;
      }
      value = value.replace(/[^0-9.]/, "");
      return value;
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.text-title {
  color: black;
  font-weight: 500;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
